import { TBlockchain } from 'src/types';

export function isBitcoinAddress(addr: string): boolean {
  return (
    /^1[0-9A-Za-z]{25,34}$/.test(addr) || // P2PKH
    /^3[0-9A-Za-z]{25,34}$/.test(addr) || // P2SH
    /^bc1[0-9A-Za-z]{39,59}$/.test(addr) // Bech32
  );
}

export function isEthereumAddress(addr: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(addr);
}

export function isTronAddress(addr: string): boolean {
  return /^T[A-Za-z1-9]{33}$/.test(addr);
}

export function isEthereumTransactionHash(hash: string): boolean {
  return /^0x[a-fA-F0-9]{64}$/.test(hash);
}

export function isBitcoinTransactionHash(hash: string): boolean {
  return /^[0-9A-Za-z]{64}$/.test(hash);
}

export function isTronTransactionHash(hash: string): boolean {
  return /^[0-9A-Za-z]{64}$/.test(hash);
}

export const isEVMChain = (chain: TBlockchain): boolean => {
  return chain === 'ethereum' || chain === 'tron';
};
